/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Box,
  Chip,
  IconButton,
  Divider,
  CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import "moment/locale/th";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Label } from "reactstrap";
import TSSelect2 from "components/Forms/TSSelect2";
import { FinanceBudgetService } from "_services/financebudget.service";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  headerCard: {
    backgroundColor: "#f4f7fc",
    padding: theme.spacing(2),
    borderRadius: 8,
    marginBottom: theme.spacing(3),
    border: "1px solid #e2e8f0"
  },
  infoLabel: {
    fontSize: "13px",
    color: "#64748b"
  },
  infoValue: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#1e293b"
  },
  formSection: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2),
    borderRadius: 8,
    border: "1px solid #e0e0e0",
    marginBottom: theme.spacing(3),
    overflow: "visible !important",
    position: "relative",
    zIndex: 20
  },
  tableHeadCell: {
    backgroundColor: "#0284c7",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "13px"
  },
  settleBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#fef3c7",
    borderRadius: 8,
    border: "1px solid #fde68a",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  datetimeInputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    zIndex: 20,
    "& .rdt": {
      width: "100%",
      position: "relative"
    },
    "& .rdtPicker": {
      position: "absolute",
      top: "calc(100% + 4px)",
      left: 0,
      zIndex: 99999,
      backgroundColor: "#ffffff",
      boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
      borderRadius: "8px",
      border: "1px solid #cbd5e1",
      fontSize: "13px",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "& table": {
        margin: 0
      },
      "& table th, & table td": {
        fontSize: "13px",
        height: "26px",
        padding: "2px"
      },
      "& .rdtSwitch": {
        fontSize: "13px",
        fontWeight: "bold"
      }
    },
    "& input": {
      width: "100%",
      height: "38px",
      borderRadius: "4px",
      border: "1px solid #cbd5e1",
      padding: "8px 12px 8px 36px",
      fontSize: "14px",
      color: "#1e293b",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      boxSizing: "border-box",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "&:hover": {
        borderColor: "#94a3b8"
      },
      "&:focus": {
        outline: "none",
        borderColor: "#2563eb",
        boxShadow: "0 0 0 2px rgba(37,99,235,0.1)"
      }
    }
  },
  datetimeIcon: {
    position: "absolute",
    left: "10px",
    color: "#64748b",
    zIndex: 1,
    pointerEvents: "none",
    fontSize: "1rem"
  }
}));

export default function ProtectPaymentManager({
  open,
  onClose,
  protectId,
  protectNumber,
  onUpdated
}) {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [protectData, setProtectData] = useState(null);
  const [subActivities, setSubActivities] = useState([]);
  const [strategies, setStrategies] = useState([]);

  // Add payment form
  const [datePay, setDatePay] = useState(moment().format("YYYY-MM-DD"));
  const [said, setSaid] = useState("");
  const [stratId, setStratId] = useState("");
  const [payAmount, setPayAmount] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSettling, setIsSettling] = useState(false);

  useEffect(() => {
    if (open && (protectId || protectNumber)) {
      loadDetails();
      loadLookups();
    }
  }, [open, protectId, protectNumber]);

  const loadLookups = async () => {
    try {
      const [saRes, stRes] = await Promise.all([
        FinanceBudgetService.getSubActivities(),
        FinanceBudgetService.getStrategies()
      ]);
      if (saRes.data.success) setSubActivities(saRes.data.data);
      if (stRes.data.success) setStrategies(stRes.data.data);
    } catch (err) {
      console.error("Load payment lookups error:", err);
    }
  };

  const loadDetails = async () => {
    setLoading(true);
    try {
      let res;
      if (protectId) {
        res = await FinanceBudgetService.getProtectById(protectId);
      } else {
        res = await FinanceBudgetService.getProtectByNumber(protectNumber);
      }
      if (res.data.success) {
        setProtectData(res.data.data);
        // Default pay amount to remaining if empty
        if (!payAmount && res.data.data.remainToPay > 0) {
          setPayAmount(res.data.data.remainToPay);
        }
      }
    } catch (err) {
      console.error("Load protect detail error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddPayment = async e => {
    e.preventDefault();
    if (!payAmount || parseFloat(payAmount) <= 0) {
      alert("กรุณาระบุจำนวนเงินที่ต้องการเบิกจ่าย");
      return;
    }

    const payVal = parseFloat(payAmount);
    if (payVal > protectData.remainToPay) {
      if (
        !window.confirm(
          "ยอดเงินที่เบิกจ่ายมากกว่ายอดคงเหลือที่กันไว้ ต้องการดำเนินการต่อหรือไม่?"
        )
      ) {
        return;
      }
    }

    setIsSubmitting(true);
    try {
      const payload = {
        number: protectData.number,
        calYear: protectData.year,
        project: protectData.project,
        datePay: datePay,
        said: said,
        stratId: stratId ? parseInt(stratId) : null,
        pay: payVal,
        protect: protectData.money
      };

      const res = await FinanceBudgetService.addPayment(payload);
      if (res.data.success) {
        setPayAmount("");
        await loadDetails();
        if (onUpdated) onUpdated();
      }
    } catch (err) {
      alert(
        "เกิดข้อผิดพลาดในการบันทึกการเบิกจ่าย: " +
          (err.response?.data?.message || err.message)
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeletePayment = async payId => {
    if (!window.confirm("ต้องการลบรายการเบิกจ่ายนี้ใช่หรือไม่?")) return;
    try {
      const res = await FinanceBudgetService.deletePayment(payId);
      if (res.data.success) {
        await loadDetails();
        if (onUpdated) onUpdated();
      }
    } catch (err) {
      alert("เกิดข้อผิดพลาดในการลบรายการ: " + err.message);
    }
  };

  const handleSettle = async () => {
    if (!protectData) return;
    const diffRefund = Math.max(0, protectData.money - protectData.totalPaid);
    const confirmMsg =
      `ยืนยันการปิดรายการเบิกจ่ายของใบกันเงินเลขที่ ${protectData.number}?\n` +
      `- ยอดเงินที่กันไว้: ${protectData.money.toLocaleString()} บาท\n` +
      `- เบิกจ่ายไปแล้ว: ${protectData.totalPaid.toLocaleString()} บาท\n` +
      `- ยอดเงินคงเหลือจะคืนเข้าโครงการ: ${diffRefund.toLocaleString()} บาท`;

    if (!window.confirm(confirmMsg)) return;

    setIsSettling(true);
    try {
      const res = await FinanceBudgetService.settleProtect(protectData.number);
      if (res.data.success) {
        alert(res.data.message || "ปิดรายการเบิกจ่ายและคืนเงินสำเร็จ");
        await loadDetails();
        if (onUpdated) onUpdated();
      } else {
        alert(res.data.message || "ไม่สามารถปิดรายการได้");
      }
    } catch (err) {
      alert(
        "เกิดข้อผิดพลาดในการปิดรายการ: " +
          (err.response?.data?.message || err.message)
      );
    } finally {
      setIsSettling(false);
    }
  };

  if (!protectData && loading) {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogContent style={{ padding: 40, textAlign: "center" }}>
          <CircularProgress />
          <Typography style={{ marginTop: 16 }}>กำลังโหลดข้อมูล...</Typography>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        disableTypography
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <Typography
          variant="h6"
          style={{ fontWeight: "bold", color: "#1e3a8a" }}
        >
          จัดการการเบิกจ่ายเงิน (เลขที่: {protectData?.number})
        </Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {protectData && (
          <>
            {/* Header Information Card */}
            <div className={classes.headerCard}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.infoLabel}>โครงการ</div>
                  <div className={classes.infoValue}>
                    {protectData.projectName || "-"}
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.infoLabel}>บริษัท/ผู้ขาย</div>
                  <div className={classes.infoValue}>
                    {protectData.companyName || "-"}
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.infoLabel}>สถานะการเบิกจ่าย</div>
                  <div>
                    {protectData.payAll === "1" ? (
                      <Chip
                        label="เบิกจ่ายครบแล้ว (ปิดงาน)"
                        color="primary"
                        size="small"
                        style={{ backgroundColor: "#10b981" }}
                      />
                    ) : protectData.totalPaid > 0 ? (
                      <Chip
                        label="เบิกจ่ายบางส่วน"
                        color="secondary"
                        size="small"
                        style={{ backgroundColor: "#0284c7" }}
                      />
                    ) : (
                      <Chip
                        label="รอเบิกจ่าย"
                        size="small"
                        style={{ backgroundColor: "#f59e0b", color: "#fff" }}
                      />
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <div className={classes.infoLabel}>ยอดเงินที่กันไว้</div>
                  <div
                    className={classes.infoValue}
                    style={{ color: "#0369a1", fontSize: "17px" }}
                  >
                    {protectData.money.toLocaleString("th-TH", {
                      minimumFractionDigits: 2
                    })}{" "}
                    บาท
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.infoLabel}>ยอดเบิกจ่ายสะสม</div>
                  <div
                    className={classes.infoValue}
                    style={{ color: "#16a34a", fontSize: "17px" }}
                  >
                    {protectData.totalPaid.toLocaleString("th-TH", {
                      minimumFractionDigits: 2
                    })}{" "}
                    บาท
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className={classes.infoLabel}>คงเหลือรอเบิกจ่าย</div>
                  <div
                    className={classes.infoValue}
                    style={{
                      color:
                        protectData.remainToPay > 0 ? "#dc2626" : "#64748b",
                      fontSize: "17px"
                    }}
                  >
                    {protectData.remainToPay.toLocaleString("th-TH", {
                      minimumFractionDigits: 2
                    })}{" "}
                    บาท
                  </div>
                </Grid>
              </Grid>
            </div>

            {/* Settle banner if not yet settled */}
            {protectData.payAll !== "1" && (
              <div className={classes.settleBox}>
                <div>
                  <Typography
                    variant="subtitle2"
                    style={{ fontWeight: "bold", color: "#92400e" }}
                  >
                    ต้องการปิดรายการและคืนเงินคงเหลือ?
                  </Typography>
                  <Typography variant="body2" style={{ color: "#b45309" }}>
                    หากการจัดซื้อ/จ้างเสร็จสิ้นแล้วและมียอดเงินเหลือ
                    ระบบจะคืนเงินส่วนต่างกลับเข้าโครงการโดยอัตโนมัติ
                  </Typography>
                </div>
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#d97706", color: "#fff" }}
                  startIcon={<CheckCircleIcon />}
                  onClick={handleSettle}
                  disabled={isSettling}
                >
                  {isSettling ? "กำลังดำเนินการ..." : "ปิดรายการ & คืนเงิน"}
                </Button>
              </div>
            )}

            {/* Add Payment Form (only enabled if not closed) */}
            {protectData.payAll !== "1" ? (
              <form onSubmit={handleAddPayment} className={classes.formSection}>
                <Typography
                  variant="subtitle2"
                  style={{
                    fontWeight: "bold",
                    marginBottom: "12px",
                    color: "#334155"
                  }}
                >
                  + บันทึกรายการเบิกจ่ายใหม่
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={3} style={{ position: "relative", zIndex: 30 }}>
                    <Label
                      style={{
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "#334155",
                        marginBottom: 6,
                        display: "inline-block"
                      }}
                    >
                      วันที่เบิกจ่าย *
                    </Label>
                    <div className={classes.datetimeInputWrapper}>
                      <i className={`far fa-calendar-alt ${classes.datetimeIcon}`} />
                      <Datetime
                        value={datePay ? moment(datePay) : null}
                        dateFormat="DD/MM/BBBB"
                        timeFormat={false}
                        closeOnSelect={true}
                        renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                        inputProps={{
                          placeholder: "วว/ดด/ปปปป",
                          "aria-label": "วันที่เบิกจ่าย",
                          required: true
                        }}
                        onChange={m => {
                          if (moment.isMoment(m)) {
                            setDatePay(m.format("YYYY-MM-DD"));
                          } else if (typeof m === "string") {
                            setDatePay(m);
                          } else if (!m) {
                            setDatePay("");
                          }
                        }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ position: "relative", zIndex: 25 }}>
                    <TSSelect2
                      label="กิจกรรมย่อย"
                      options={subActivities}
                      value={said}
                      onChange={opt => setSaid(opt ? opt.value : "")}
                      isClearable={true}
                      placeholder="-- ไม่ระบุ --"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ position: "relative", zIndex: 20 }}>
                    <TSSelect2
                      label="ยุทธศาสตร์"
                      options={strategies}
                      value={stratId}
                      onChange={opt => setStratId(opt ? opt.value : "")}
                      isClearable={true}
                      placeholder="-- ไม่ระบุ --"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ position: "relative", zIndex: 10 }}>
                    <TextField
                      label="จำนวนเงิน (บาท)"
                      type="number"
                      step="0.01"
                      fullWidth
                      size="small"
                      variant="outlined"
                      value={payAmount}
                      onChange={e => setPayAmount(e.target.value)}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} style={{ textAlign: "right" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={<AddIcon />}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "กำลังบันทึก..." : "บันทึกเบิกจ่าย"}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            ) : (
              <Box my={2}>
                <Chip
                  icon={<CheckCircleIcon />}
                  label="รายการนี้ปิดการเบิกจ่ายเรียบร้อยแล้ว ไม่สามารถเพิ่มรายการเบิกจ่ายใหม่ได้"
                  style={{
                    backgroundColor: "#dcfce7",
                    color: "#166534",
                    width: "100%",
                    padding: "8px"
                  }}
                />
              </Box>
            )}

            {/* Payments Table */}
            <Typography
              variant="subtitle2"
              style={{ fontWeight: "bold", margin: "16px 0 8px 0" }}
            >
              รายการเบิกจ่ายที่บันทึกแล้ว ({protectData.payments?.length || 0}{" "}
              รายการ)
            </Typography>
            <Paper variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableHeadCell}
                      align="center"
                      style={{ width: "5%" }}
                    >
                      #
                    </TableCell>
                    <TableCell
                      className={classes.tableHeadCell}
                      style={{ width: "18%" }}
                    >
                      วันที่เบิกจ่าย
                    </TableCell>
                    <TableCell
                      className={classes.tableHeadCell}
                      style={{ width: "32%" }}
                    >
                      กิจกรรมย่อย
                    </TableCell>
                    <TableCell
                      className={classes.tableHeadCell}
                      style={{ width: "25%" }}
                    >
                      ยุทธศาสตร์
                    </TableCell>
                    <TableCell
                      className={classes.tableHeadCell}
                      align="right"
                      style={{ width: "15%" }}
                    >
                      ยอดเงิน (บาท)
                    </TableCell>
                    {protectData.payAll !== "1" && (
                      <TableCell
                        className={classes.tableHeadCell}
                        align="center"
                        style={{ width: "5%" }}
                      >
                        ลบ
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {protectData.payments && protectData.payments.length > 0 ? (
                    protectData.payments.map((p, idx) => (
                      <TableRow key={p.id} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell>
                          {p.datePay
                            ? moment(p.datePay)
                                .add(543, "years")
                                .format("DD/MM/YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell>{p.subActivityName || "-"}</TableCell>
                        <TableCell>{p.strategyName || "-"}</TableCell>
                        <TableCell
                          align="right"
                          style={{ fontWeight: "bold", color: "#16a34a" }}
                        >
                          {p.pay.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        {protectData.payAll !== "1" && (
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              color="secondary"
                              onClick={() => handleDeletePayment(p.id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        style={{ padding: "20px", color: "#94a3b8" }}
                      >
                        ยังไม่มีรายการเบิกจ่ายสำหรับใบกันเงินนี้
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          ปิดหน้าต่าง
        </Button>
      </DialogActions>
    </Dialog>
  );
}
